<app-lot-add-photo-uploading-list-item-preview
  *ngIf="isUploaded$ | async"
  [image]="url$ | async"
  [isAuctionList]="isAuctionList"
  (remove)="remove.emit(item)"
  (openPreview)="openPreview.emit(item)"
  (setAsAuctionList)="setAsAuctionList.emit(item)"
></app-lot-add-photo-uploading-list-item-preview>

<app-lot-add-photo-uploading-list-item-progress
  *ngIf="isUploading$ | async"
  [status]="status$ | async"
  [uploadingProgress]="uploadingProgress$ | async"
></app-lot-add-photo-uploading-list-item-progress>

<app-lot-add-photo-uploading-list-item-error
  *ngIf="error$ | async as error"
  [error]="error"
></app-lot-add-photo-uploading-list-item-error>
